var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStripes = function SvgStripes(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186.864,
    height: 186.864,
    viewBox: "0 0 186.864 186.864",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_51467",
    "data-name": "Group 51467",
    transform: "translate(1114 -2024.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34429",
    "data-name": "Path 34429",
    d: "M-986.159,2211.5-1114,2083.659v29.557l98.283,98.283Z",
    fill: "#ffa900",
    opacity: 1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34430",
    "data-name": "Path 34430",
    d: "M-956.636,2211.5-1114,2054.136v29.553L-986.189,2211.5Z",
    fill: "#ed1cb5",
    opacity: 1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34431",
    "data-name": "Path 34431",
    d: "M-927.136,2211.5-1114,2024.636v29.553L-956.689,2211.5Z",
    fill: "#39fffc",
    opacity: 1,
    style: {
      isolation: "isolate"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStripes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stripes.1968e077.svg";
export { ForwardRef as ReactComponent };